import { makeStyles } from '@material-ui/core';
export default makeStyles (() => ({
    income: {
        borderBottom: '10px solid blue'
    },
    expenses: {
        borderBottom: '10px solid blue'
    },
    StudentLoan: {
        borderBottom: '10px solid blue'
    }
}))